import { Experiences } from '@/src/experiences'

export default Experiences.CardPayments.Screens.OnetimePaySchedule.Screen
